import { render, staticRenderFns } from "./SetupWizard.vue?vue&type=template&id=b6ac2178"
import script from "./SetupWizard.vue?vue&type=script&lang=js"
export * from "./SetupWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports